// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/roles/RoleCard.jsx

import React from "react";

function roleTypeLabel(role) {
  if (role?.is_system_role) return "System role";
  return role?.role_type
    ? `${String(role.role_type).replace(/_/g, " ")} role`
    : "Custom role";
}

export default function RoleCard({ role, active, onSelect }) {
  const permissionCount = Array.isArray(role?.permissions)
    ? role.permissions.length
    : 0;
  const assignmentCount = Number(role?.assignment_count || 0);
  const roleName = role?.role_name || role?.role_key || "Unnamed role";

  return (
    <button
      type="button"
      className={`enterprise-admin-role-card${active ? " active" : ""}`}
      onClick={() => onSelect?.(role)}
      aria-pressed={active}
      aria-label={`Review ${roleName} role`}
    >
      <div className="enterprise-admin-role-card-badges">
        <span className="enterprise-admin-role-type-badge">
          {roleTypeLabel(role)}
        </span>

        {role?.is_default ? (
          <span className="enterprise-admin-role-default-badge">
            Invitation default
          </span>
        ) : null}

        {role?.is_deletable === false ? (
          <span className="enterprise-admin-role-protected-badge">
            Protected
          </span>
        ) : null}
      </div>

      <strong className="enterprise-admin-role-card-title">{roleName}</strong>

      <p className="enterprise-admin-role-card-description">
        {role?.description || "Organization authority role."}
      </p>

      <div className="enterprise-admin-role-card-facts" aria-label="Role summary">
        <span>
          <b>{permissionCount}</b>{" "}
          {permissionCount === 1 ? "permission" : "permissions"}
        </span>
        <span className="enterprise-admin-role-card-fact-separator" aria-hidden="true">
          •
        </span>
        <span>
          <b>{assignmentCount}</b>{" "}
          {assignmentCount === 1 ? "member" : "members"}
        </span>
      </div>

      <span className="enterprise-admin-role-card-selection" aria-hidden="true">
        {active ? "Selected" : "Review role"}
      </span>
    </button>
  );
}
